import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import web from '../../../assests/devlopment/web.png'
import mobile from '../../../assests/devlopment/mobile.png'
import ec from '../../../assests/devlopment/ec.png'
import ms from '../../../assests/devlopment/ms.png'
import { Helmet } from "react-helmet-async";
import Service from '../../../assests/service.png'

const items = [
  {
    icon: web,
    title: "Web Development",
    description: "We are building tailored Web Solutions that drives real business results.",
    route: "/web-development",
  },
  {
    icon: mobile,
    title: "Mobile Development",
    description: "From Idea to App Store – Mobile App Development That Delivers results.",
    route: "/mobile-development",
  },
  {
    icon: ms,
    title: "AI/ML Development",
    description: "We are building Intelligent Systems That Learn, Predict, and Evolve.",
    route: "/AI-ML-devlopment",
  },
  {
    icon: ms,
    title: "Managed Services",
    description: "You can focus on Growth While TekIT is handling the Tech.",
    route: "/managed-services",
  },
  {
    icon: ec,
    title: "E Commerce Development",
    description: "Boost your Sales with Engaging, User-Friendly E-commerce Platforms.",
    route: "/eCommerce",
  },
];

const Services = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className=" py-16 pt-40 bg-[#f4f5f6] bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${Service})` }}
    >
      <Helmet>
        <title>Reliable IT Services & Expert IT Staffing Solutions for Your Business </title>
        <meta name="description" content="Enhance your operations with our IT services and staff augmentation. We offer expert tech solutions and flexible staffing to meet your business needs efficiently." />
        <meta name="keywords" content="IT Staff Augmentation, Technology Staffing Solutions, Contract IT Staffing, IT Talent Augmentation, IT Resource Management, Temporary IT Staffing, Skilled IT Professionals, Tech Talent Acquisition, Remote IT Staffing, IT Workforce Solutions, Custom Software Development, Managed IT Services, IT Consulting Services, Enterprise IT Solutions, Web Development Services,Mobile App Development, Digital Marketing Service" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-10 ">
        {items.map((item, idx) => (
          <div
            key={idx}
            onClick={() => navigate(item.route)}
            className="group relative rounded-xl p-5 cursor-pointer transition-all duration-300"
          >
            <div className="flex items-center gap-3">
              <div className="bg-[#09588D]  p-2 rounded-md shadow-sm transition-colors duration-300  ">
                <img src={item.icon} alt='item.title' className='h-10 w-10' />
              </div>
              <h3 className="font-bold text-gray-800 2xl:text-[26px]  lg:text-[20px] text-[42px] font-recoleta  hover:translate-y-0 hover:opacity-100 transition-all">{item.title}</h3>
            </div>

            <div className="overflow-hidden mt-0 lg:block hidden">
              <div className="transform translate-y-8 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out -mt-1 px-16">
                <p className="text-gray-500 text-[24px] 2xl:text-[20px] lg:text-[16px] mb-2 font-recoleta lg:w-[260px]">{item.description}</p>
                <button

                  className="text-red-500 text-[24px] 2xl:text-[20px] lg:text-[16px] font-semibold flex items-center gap-1  font-recoleta"
                >
                  Know More <span className="text-lg">―</span>
                </button>
              </div>
            </div>
            <div className=" mt-0 block lg:hidden lg:ml-8">
              <div className=" -mt-1 px-16">
                <p className="text-gray-500  text-[38px] mb-2 font-recoleta">{item.description}</p>
                <button
                  onClick={() => navigate(item.route)}
                  className="text-red-500 text-[32px] font-semibold flex items-center gap-1  font-recoleta"
                >
                  Know More <span className="text-[32px]">―</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Services;